require('./RARadioButtonStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class RARadioButtonStep extends React.Component {
    constructor(props) {
        super(props);
        this.handleSelectedButton = this.handleSelectedButton.bind(this);
    }

    buildTooltip() {
        const { tooltipContent } = this.props;

        if (tooltipContent) {
            return (
                <OKTooltip
                    content={tooltipContent}
                    placement="right"
                    offset={[10, 0]}
                />
            );
        }
    }

    handleSelectedButton(e) {
        this.props.changeSelectedOption(e);
    }

    render() {
        const {
            selectedValue,
            explanationText,
            titleText,
            subTitleText,
            radioButtons,
            nameComponent,
            idPrefix,
            className,
            disabled,
            titleTooltip,
        } = this.props;
        const showTooltip = this.buildTooltip();
        const answers = radioButtons.map(data => {
            return (
                <RadioButton
                    key={data.id + idPrefix}
                    disabled={disabled}
                    label={
                        <div className="goal-radio-buttons__label-container">
                            <div className="goal-radio-buttons__label-title">
                                {data.label.title}
                            </div>
                            <div className="goal-radio-buttons__label-description">
                                {data.label.description}
                            </div>
                        </div>
                    }
                    value={data.id}
                />
            );
        });

        return (
            <section className="goal-radio-buttons">
                <div className="goal-radio-buttons__head">
                    <div className="goal-radio-buttons__title">
                        <h2>
                            {titleText} {titleTooltip}
                        </h2>
                        <div>{showTooltip}</div>
                    </div>
                    {subTitleText && (
                        <div className="goal-radio-buttons__subtitle">
                            {subTitleText}
                        </div>
                    )}
                    {explanationText && (
                        <div className="goal-radio-buttons__explanation">
                            {explanationText}
                        </div>
                    )}
                </div>
                <div className="goal-radio-buttons__buttons-container">
                    <RadioButtonGroup
                        className={className}
                        name={nameComponent}
                        idPrefix={idPrefix}
                        selectedValue={selectedValue}
                        onChange={this.handleSelectedButton}
                    >
                        {answers}
                    </RadioButtonGroup>
                </div>
            </section>
        );
    }
}

RARadioButtonStep.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    selectedValue: PropTypes.string.isRequired,
    titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
    subTitleText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    explanationText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    radioButtons: PropTypes.array.isRequired,
    nameComponent: PropTypes.string.isRequired,
    tooltipContent: PropTypes.string,
    changeSelectedOption: PropTypes.func.isRequired,
    idPrefix: PropTypes.string.isRequired,
    titleTooltip: PropTypes.any,
};

module.exports = RARadioButtonStep;
